import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTabularDeleteIcon = ({ fill = '#616061', ...props }: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill={fill} {...props}>
    <path fill={fill} d="M1 2h3V0h8v2h3v2H1z" />
    <path fill={fill} fillRule="evenodd" d="M13 6H3v10h10z" clipRule="evenodd" />
  </svg>
);
export default SvgTabularDeleteIcon;
